import { Component, Input, ViewChild, OnInit, EventEmitter } from '@angular/core';
import { HttpService } from '../../services/dataAccess.service';
import { CoreService } from '../../services/core.service';
import { IdNameBase, MyCompanyFilesAddStorage, MyCompanyFilesArbo, MyCompanyFilesAttribute, MyCompanyFilesCustomerUser, MyCompanyFilesInfoStoragePublisherDto, MyCompanyFilesModel, MyCompanyFilesQueovalAttribute, MyCompanyFilesStorage } from '../../models/MyCompanyFiles/my-company-files.model';
import { Observable, of } from 'rxjs';
import { ChangeDetectorRef } from '@angular/core';
import { forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import { selectMultipleChange, SelectMultipleComponent } from '../select-multiple/select-multiple.component';
import { ToastService } from '../../toast';
import { QResult } from '../../models';
import { Output } from '@angular/core';

@Component({
  selector: 'q-config-client-mcf',
  templateUrl: './config-client-mcf.component.html',
  styleUrls: ['./config-client-mcf.component.css']
})

export class ConfigClientMcfComponent implements OnInit {

  // #region DIRECTIVES

  /** Nom du groupe du dossier client (si existant)*/
  @Input('group') set SetGroup(value: string) {
    this.group = !value ? '' : value;
  }

  /** Nom du dossier client (si existant)*/
  @Input('storage') set SetStorage(value: string) {
    this.storage = !value ? '' : value;
  }

  @Input('idClient') idClient: string;

  @Output() save: EventEmitter<MyCompanyFilesModel> = new EventEmitter<MyCompanyFilesModel>(true);
  //#endregion

  @ViewChild('SelectMultipleProps') selectMultipleProps: SelectMultipleComponent;

  public newClient: MyCompanyFilesAddStorage = new MyCompanyFilesAddStorage();
  public updateClient: MyCompanyFilesAddStorage = new MyCompanyFilesAddStorage();

  // liste des dossiers clients existants de My company files (pour lier sans créer de nouveau dossier)
  public storageList: Array<MyCompanyFilesInfoStoragePublisherDto> = new Array<MyCompanyFilesInfoStoragePublisherDto>();
  //liste des groupes dans my company files (dossiers parents contenants les dossiers clients)
  public ListGroup: Array<IdNameBase> = new Array<IdNameBase>();
  //les modèles d'arborescences servent à créer un client avec des sous-dossiers (suivant le(s) modèle(s) choisi)
  public ListArbos: Array<MyCompanyFilesArbo> = new Array<MyCompanyFilesArbo>();
  public selectedArbosList: Array<MyCompanyFilesArbo> = new Array<MyCompanyFilesArbo>();

  //liste des contacts du client
  public contactsList: Array<MyCompanyFilesCustomerUser> = new Array<MyCompanyFilesCustomerUser>();
  public selectedContactsList: Array<MyCompanyFilesCustomerUser> = new Array<MyCompanyFilesCustomerUser>();
  // liste des comptes collaborateurs de my company files
  public collabsList: Array<MyCompanyFilesCustomerUser> = new Array<MyCompanyFilesCustomerUser>();
  public selectedCollabsList: Array<MyCompanyFilesCustomerUser> = new Array<MyCompanyFilesCustomerUser>();

  public lstProps: Array<MyCompanyFilesQueovalAttribute> = new Array<MyCompanyFilesQueovalAttribute>();
  public lstSelectedProps: Array<MyCompanyFilesQueovalAttribute> = new Array<MyCompanyFilesQueovalAttribute>();

  public listsLoadedOnUpdate: boolean = false;
  /** Nom du groupe pour le client existant */
  public group: string = '';
  /** Nom du dossier client existant*/
  public storage: string;



  /** Nom du nouveau client */
  public clientName: string = '';
  /** Nom du groupe pour le nouveau client */
  public selectedGroup: string = '';



  //private model: BObjectModel;

  // nom des propriétés à filtrer (+ ordre dans lequel les éléments sont triés) pour les listes contactsList et collabsList ( de type MyCompanyFilesCustomerUser)
  public filterableProperties: Array<string> = ['LastName', 'FirstName'];

  public loadingModal: boolean = false;
  public isSaving: boolean = false;

  // #region CONSTRUCTEUR
  constructor(
    private http: HttpService,
    private indParam: CoreService,
    private cd: ChangeDetectorRef,
    private toast: ToastService,
  ) { }
  // #endregion

  public ngOnInit(): void {
    this.newClient.ListArboId = [];
    this.newClient.ListCustomerUser = [];
    this.newClient.ListProviderUser = [];

    if (!this.storage)
      this.storage = '';
    else {
      this.GetStorageList(this.storage);

    }   
 
    //#region initialisation de la liste des clients (storage chez my company files) à une liste vide
    if (!this.storageList) {
      this.storageList = [];
      let emptyLine: MyCompanyFilesInfoStoragePublisherDto = new MyCompanyFilesInfoStoragePublisherDto();
      emptyLine.Id = '';
      emptyLine.Name = '-----';
      this.storageList.unshift(emptyLine);
    }
    //#endregion
    this.loadingModal = true;
    //#region récupération du nom du client
    const clientName: Observable<MyCompanyFilesModel> = this.http.getHttp<MyCompanyFilesModel>(`${this.indParam.AppParams.apiUrl}api/myCompanyFiles/CLIENT_NAME/${this.idClient}`).pipe(
      map((result: MyCompanyFilesModel) => {
        this.clientName = result.Value;
        return result;
      })
    );
    //#endregion
    //#region récupération de la liste des dossiers dans my company files
    const groupList: Observable<MyCompanyFilesModel> = this.http.getHttp<MyCompanyFilesModel>(`${this.indParam.AppParams.apiUrl}api/myCompanyFiles/GROUP_LIST/0`).pipe(
      map((result: MyCompanyFilesModel) => {
        this.ListGroup = result.ListGroup;
        if (!this.ListGroup) {
          this.ListGroup = [];
        }
        let emptyLine: IdNameBase = new IdNameBase();
        emptyLine.Id = '';
        emptyLine.Name = '-----';
        this.ListGroup.unshift(emptyLine);
        return result;
      })
    );
    //#endregion
  
    forkJoin([groupList, clientName]).subscribe(() => {
      this.loadingModal = false;
        this.GetStorageDatas(this.storage);
    });
    // #endregion
  }

  // récupères les dossiers de clients par rapport au groupe sélectionné (pour la partie client existant)
  public GetStorageList(pSelectedStorage: string = ''): void {
    let emptyLine: MyCompanyFilesInfoStoragePublisherDto = new MyCompanyFilesInfoStoragePublisherDto();
    emptyLine.Id = '';
    emptyLine.Name = '-----';
    // si aucun groupe n'est sélectionné dans le cadre client existant
    // on vide la liste des dossiers clients et on vide la valeur du dossier sélectionné.
    if (!this.group) {
      this.storageList = [];
      this.storageList.unshift(emptyLine);
      this.storage = pSelectedStorage;
      this.cd.detectChanges();
      return;
    }
    // récupération de la liste des dossiers clients dans le groupe sélectionné
    this.http.getHttp<MyCompanyFilesModel>(`${this.indParam.AppParams.apiUrl}api/myCompanyFiles/STORAGE_LIST/${this.group}`).subscribe(
      (result: MyCompanyFilesModel) => {
        this.storageList = result.ListInfoStoragePublisherDto;
        this.storage = pSelectedStorage;
        if (!this.storageList) {
          this.storageList = [];
        }
        this.storageList.unshift(emptyLine);
        this.cd.detectChanges();
        return result;
      });
  }

  public GetStorageDatas(pIdStorage: string): void {

      //#region récupération du modèle de propriétés sélectionnées
    const propsList: Observable<QResult<Array<MyCompanyFilesQueovalAttribute>>> = this.http.getHttp<QResult<Array<MyCompanyFilesAttribute>>>(`${this.indParam.AppParams.apiUrl}api/myCompanyFiles/GET_PROPS_MODEL/${this.idClient}`).pipe(
        map((result: QResult<Array<MyCompanyFilesQueovalAttribute>>) => {
          this.lstSelectedProps = [];
          this.lstProps = [];
          result.Value.forEach(prop => {
            if (prop.Selected) {
              this.lstSelectedProps.push(JSON.parse(JSON.stringify(prop)));
            } else {
              this.lstProps.push(prop)
            }
          });
          return result;
        }));
        //#endregion
    

    //#region récupération des contacts du client
    const contactList: Observable<MyCompanyFilesModel> = this.http.getHttp<MyCompanyFilesModel>(`${this.indParam.AppParams.apiUrl}api/myCompanyFiles/GET_CONTACTS/${this.idClient}`).pipe(
      map((result: MyCompanyFilesModel) => {
        this.contactsList = result.Contacts;
        return result;
      }));
    //#endregion
    //#region récupération des contacts du client
    const collabList: Observable<MyCompanyFilesModel> = this.http.getHttp<MyCompanyFilesModel>(`${this.indParam.AppParams.apiUrl}api/myCompanyFiles/GET_COLLABS/0`).pipe(
      map((result: MyCompanyFilesModel) => {
        this.collabsList = result.Contacts;
        return result;
      }));
    //#endregion
    //#region récupération de la liste des dossiers dans my company files
    const arboList: Observable<MyCompanyFilesModel> = this.http.getHttp<MyCompanyFilesModel>(`${this.indParam.AppParams.apiUrl}api/myCompanyFiles/ARBO_LIST/0`).pipe(
      map((result: MyCompanyFilesModel) => {
        this.ListArbos = result.ListArbo;
        if (!this.ListArbos) {
          this.ListArbos = [];
        }
        return result;
      })
    );
    //#endregion
    this.listsLoadedOnUpdate = false;
    forkJoin([propsList, arboList, contactList, collabList]).subscribe(() => {
      if (!pIdStorage) {
        this.listsLoadedOnUpdate = true;
        return;
      }
      
      this.http.getHttp<QResult<MyCompanyFilesStorage>>(`${this.indParam.AppParams.apiUrl}api/myCompanyFiles/GET_STORAGE_DATA/${pIdStorage}`).subscribe(
        (result: QResult<MyCompanyFilesStorage>) => {
          this.selectedArbosList = [];
          for (let i: number = 0; i < this.ListArbos.length; i++) {
            const arbo: MyCompanyFilesArbo = this.ListArbos[i];
            if (result?.Value?.ListArboId?.length > 0 && result.Value.ListArboId.includes(Number(arbo.Id))) {
              this.selectedArbosList.push(arbo);
              this.ListArbos.splice(i, 1);
              i--;
            }
          }

          this.selectedCollabsList = [];
          for (let i: number = 0; i < this.collabsList.length; i++) {
            const collab: MyCompanyFilesCustomerUser = this.collabsList[i];
            if (result?.Value?.ListProviderUser?.length > 0 && result.Value.ListProviderUser.includes(collab.Email)) {
              this.selectedCollabsList.push(collab);
              this.collabsList.splice(i, 1);
              i--;
            }
          }

          this.selectedContactsList = [];
          result?.Value?.ListCustomerUser.forEach(customer => {
            this.contactsList = this.contactsList.filter(contact => contact.Email != customer.Email);
            this.selectedContactsList.push(customer);
          });

          this.selectedContactsList = [];
          result?.Value?.ListCustomerUser.forEach(customer => {
            this.contactsList = this.contactsList.filter(contact => contact.Email != customer.Email);
            this.selectedContactsList.push(customer);
          });


          this.lstProps = JSON.parse(JSON.stringify(this.lstProps.concat(this.lstSelectedProps)));
          this.lstSelectedProps = [];
          result?.Value?.ListAttribute.forEach(attr => {
            this.lstSelectedProps.push(new MyCompanyFilesQueovalAttribute(attr.Value, attr.Name, attr.Value));
            //const iProp = this.lstProps.findIndex(prop => prop.Name.toLowerCase() == attr.Name.toLowerCase());
            //if (iProp > -1) {
            //  this.lstSelectedProps.push(this.lstProps[iProp]);
            //  this.lstProps.splice(iProp, 1);
            //} else {
            //  this.lstSelectedProps.push(new MyCompanyFilesQueovalAttribute(attr.Name, attr.Name, attr.Value));
            //}
          });


          if (this.selectedArbosList && this.selectedArbosList.length > 0) {
            this.updateClient.ListArboId = this.selectedArbosList.map((arbo: MyCompanyFilesArbo) => parseInt(arbo.Id));
          }
          else {
            this.updateClient.ListArboId = [];
          }

          if (this.selectedContactsList && this.selectedContactsList.length > 0) {
            this.updateClient.ListCustomerUser = this.selectedContactsList.map((contact: MyCompanyFilesCustomerUser) => {
              const customer: MyCompanyFilesCustomerUser = contact;

              //Initials, nom et prénom obligatoires donc vérification de valeurs présente 
              // + ajout de valeurs par défaut si vide.
              if (!contact.FirstName)
                contact.FirstName = 'X';
              if (!contact.LastName)
                contact.LastName = 'X';
              if (!customer.Initials) {
                customer.Initials = `${contact.FirstName[0]}${contact.LastName[0]}`;
              }
              customer.Initials = customer.Initials.slice(0, 5);
              customer.IsFr = true;
              return customer;
            });
          }
          else {
            this.updateClient.ListCustomerUser = [];
          }

          if (this.selectedCollabsList && this.selectedCollabsList.length > 0) {
            this.updateClient.ListProviderUser = this.selectedCollabsList.map((contact: MyCompanyFilesCustomerUser) => {
              return contact.Email;
            });
          }
          else {
            this.updateClient.ListProviderUser = [];
          }


          if (this.lstSelectedProps && this.lstSelectedProps.length > 0) {
            this.updateClient.ListAttribute = JSON.parse(JSON.stringify(this.lstSelectedProps));
          }
          else {
            this.updateClient.ListArboId = [];
          }

          this.listsLoadedOnUpdate = true;
        });
    });  
  }

  public Save(pClient: MyCompanyFilesAddStorage): void {
    if (this.isSaving) {
      this.toast.showInfoToast('une sauvegarde est déjà en cours.');
      return;
    }

    let request: Observable<MyCompanyFilesModel>
    //si un client existant est séléctionné
    //update le BO avec l'IdStorage et l'IdGroup sans faire d'appel à l'API my company files.
    if (this.storage) {
      this.isSaving = true;
      const model: MyCompanyFilesModel = new MyCompanyFilesModel();
      model.Mode = 'LINK_CLIENT';
      model.IdDonnee = this.idClient;
      model.IdStorage = this.storage;
      model.IdGroup = this.group;
      request = this.http.postHttp<MyCompanyFilesModel>(`${this.indParam.AppParams.apiUrl}api/myCompanyFiles/`, model);
    }
    //si aucun client existant sélectionné
    // créer le nouveau client avant d'update le BO avec l'IdStorage et l'IdGroup
    else {
      if (!this.selectedGroup) {
        this.toast.showInfoToast('veuillez choisir un groupe auquel affecter votre client.');
        return;
      }
      this.isSaving = true;
      const model: MyCompanyFilesAddStorage = new MyCompanyFilesAddStorage();
      //#region ajoute les arborescence sélectionnées au modèle
      model.ListArboId = pClient.ListArboId;
      //#endregion

      model.GroupeId = parseInt(this.selectedGroup);
      //#region ajoute les propriétés sélectionnées au modèle
      model.ListAttribute = this.lstSelectedProps.map(attr => new MyCompanyFilesAttribute(attr.Name, attr.CodeQvl));
      //#endregion

      //#region ajoute les contacts sélectionnés au modèle
      model.ListCustomerUser = pClient.ListCustomerUser;
      //#endregion
      //#region ajoute les collaborateurs sélectionnés au modèle
      model.ListProviderUser = !pClient.ListProviderUser || pClient.ListProviderUser.length == 0 ? this.collabsList.map(collab => collab.Email) : pClient.ListProviderUser;
      //#endregion

      model.Name = this.clientName;
      //ident du BO pour l'update après création du client
      model.AccessToken = this.idClient;
      request = this.http.postHttp<MyCompanyFilesModel>(`${this.indParam.AppParams.apiUrl}api/myCompanyFiles/ADD_STORAGE`, model);
    }

    request.subscribe((response: MyCompanyFilesModel) => {
      this.isSaving = true;
      this.save.emit(response);
    });
  }

  public OnCollabsListChange(event: selectMultipleChange, client: MyCompanyFilesAddStorage): void {
    if (event && event.selectedValues && event.selectedValues.length > 0) {
      client.ListProviderUser = event.selectedValues.map((contact: MyCompanyFilesCustomerUser) => {
        return contact.Email;
      });
    }
    else {
      client.ListProviderUser = [];
    }
  }

  public OnContactListChange(event: selectMultipleChange, client: MyCompanyFilesAddStorage): void {
    if (event && event.selectedValues && event.selectedValues.length > 0) {
      client.ListCustomerUser = event.selectedValues.map((contact: MyCompanyFilesCustomerUser) => {
        const customer: MyCompanyFilesCustomerUser = contact;

        //Initials, nom et prénom obligatoires donc vérification de valeurs présente 
        // + ajout de valeurs par défaut si vide.
        if (!contact.FirstName)
          contact.FirstName = 'X';
        if (!contact.LastName)
          contact.LastName = 'X';
        if (!customer.Initials) {
          customer.Initials = `${contact.FirstName[0]}${contact.LastName[0]}`;
        }
        customer.Initials = customer.Initials.slice(0, 5);
        customer.IsFr = true;
        return customer;
      });
    }
    else {
      client.ListCustomerUser = [];
    }
  }
  public OnPropChange(event: selectMultipleChange): void {

    if (event && event.selectedValues && event.selectedValues.length > 0) {
      this.lstSelectedProps = event.selectedValues;
    }
    else {
      this.lstSelectedProps = [];
    }
  }

  public OnArboListChange(event: selectMultipleChange, client: MyCompanyFilesAddStorage): void {
    if (event && event.selectedValues && event.selectedValues.length > 0) {
      client.ListArboId = event.selectedValues.map((arbo: MyCompanyFilesArbo) => parseInt(arbo.Id));
    }
    else {
      client.ListArboId = [];
    }
  }
}
